// Instalacja APP na ekranie (PWA) - 1:1 ze starej APP (vite-dashboard/src/main.js _pwaTriggerInstall): zdarzenie
// `beforeinstallprompt` łapane od startu (import w main.tsx, zanim przepadnie), natywne okno przeglądarki, gdy jest;
// inaczej instrukcja. Android - bez PWA (właściciel 29.10: z aplikacją powiadomienia przychodziły dwa razy), zawsze
// instrukcja pobrania aplikacji TermometrWifi (/pobierz/android). Aplikacja ze sklepu (Capacitor, docs/pwa/USTALENIA.md
// „Aplikacja natywna”) - instalować nie ma czego.
import { Capacitor } from "@capacitor/core";
import { AppShortcuts } from "@capawesome/capacitor-app-shortcuts";

interface ZdarzenieInstalacji extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: string }>;
}

let zdarzenie: ZdarzenieInstalacji | null = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  zdarzenie = e as ZdarzenieInstalacji;
});
window.addEventListener("appinstalled", () => { zdarzenie = null; });

export type Platforma = "android" | "iphone" | "komputer";

/** Aplikacja ze Sklepu Play / App Store (APP z serwera w powłoce Capacitor), nie przeglądarka. */
export const natywna = () => Capacitor.isNativePlatform();

/** Otwarta z ikony na ekranie (nie w karcie przeglądarki). */
export const zainstalowana = () =>
  (navigator as Navigator & { standalone?: boolean }).standalone === true || matchMedia("(display-mode: standalone)").matches;

/** iPhone, iPod i iPad (iPadOS przedstawia się jak Mac - rozpoznany po ekranie dotykowym). */
export const iPhone = () => /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const platforma = (): Platforma => (iPhone() ? "iphone" : /Android/i.test(navigator.userAgent) ? "android" : "komputer");

/** Skróty z ikony aplikacji ze sklepu (przytrzymanie ikony) - ta sama lista co `shortcuts` w public/manifest.json
 *  (PWA). Kliknięcie skrótu - `idz(adres)`. Zwraca wyłączenie nasłuchu. */
export function skrotyAplikacji(idz: (adres: string) => void, t: (s: string) => string): () => void {
  if (!natywna()) return () => {};
  let koniec = false;
  let nasluch: { remove: () => Promise<void> } | null = null;
  void (async () => {
    try {
      const m = (await (await fetch("/manifest.json")).json()) as { shortcuts?: { name: string; url: string }[] };
      const lista = m.shortcuts ?? [];
      await AppShortcuts.set({ shortcuts: lista.map((s) => ({ id: s.url, title: t(s.name) })) });
      const n = await AppShortcuts.addListener("click", (e) => idz(e.shortcutId));
      if (koniec) void n.remove();
      else nasluch = n;
    } catch { /* bez skrótów - aplikacja działa dalej */ }
  })();
  return () => {
    koniec = true;
    void nasluch?.remove();
  };
}

/** Przeglądarka na Androidzie - zamiast PWA aplikacja TermometrWifi (instrukcja pobrania, bez powiadomień przeglądarki). */
export const androidBezPwa = () => !natywna() && platforma() === "android";

/** Natywne okno instalacji przeglądarki. false - go nie ma (iPhone, Firefox, Chrome przed zdarzeniem) albo Android
 *  (aplikacja zamiast PWA) - pokaż instrukcję. */
export async function instaluj(): Promise<boolean> {
  if (!zdarzenie || androidBezPwa()) return false;
  try {
    await zdarzenie.prompt();
    if ((await zdarzenie.userChoice).outcome === "accepted") zdarzenie = null;
    return true;
  } catch {
    return false;
  }
}
